import BaseModal from "components/Modals/BaseModal";
import s from './BaseModal.module.css';
import l from './LoginModal.module.css';
const LoginModal = ({onClose, content}) => {

    const goToLogin = () => {
        // Redirect to login page
        window.location.href = "/loginsignup";
    }
    return ( 
        <BaseModal height="20rem" onClose={onClose}>
            <div className={l.loginModalContainer}>
                <div className={l.title}>
                    Ready to save and export contacts?
                </div>
                <div className={l.subtitle}>
                    Log in or sign up <br />&<br /> join other industry leaders across dozens of verticals.
                </div>
                <div className={`${s.blackButton} ${l.button}`} onClick={goToLogin}>OK</div>
            </div>
            
        </BaseModal>
     );
}

export default LoginModal;